import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export const sideItemsApi = {
  getSideItems: async (filters: any = {}) => {
    const { category, search } = filters;
    let url = `${API_URL}/api/admin/side-items?`;

    if (category) url += `category=${encodeURIComponent(category)}&`;
    if (search) url += `search=${encodeURIComponent(search)}&`;

    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  createSideItem: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/side-items`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateSideItem: async (id: string, data: any) => {
    const response = await axios.patch(`${API_URL}/api/admin/side-items/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  deleteSideItem: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/side-items/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
